import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AudioSettings {
  masterVolume: number;
  bgmVolume: number;
  seVolume: number;
}

interface AudioState {
  // Settings
  audioSettings: AudioSettings;
  
  // BGM Unlocks
  bgmUnlocks: Record<number, boolean>; // bgm id -> unlocked status
  
  // Actions
  updateAudioSettings: (settings: Partial<AudioSettings>) => void;
  unlockBgm: (bgmId: number) => boolean;
}

export const useAudioStore = create<AudioState>()(
  persist(
    (set, get) => ({
      // Initial state
      audioSettings: {
        masterVolume: 1.0,
        bgmVolume: 0.5,
        seVolume: 0.5,
      },
      bgmUnlocks: { 1: true }, // BGM 1 is unlocked by default

      // Actions
      updateAudioSettings: (settings) =>
        set((state) => ({
          audioSettings: { ...state.audioSettings, ...settings },
        })),

      unlockBgm: (bgmId) => {
        const { bgmUnlocks } = get();
        if (!bgmUnlocks[bgmId]) {
          set((state) => ({
            bgmUnlocks: {
              ...state.bgmUnlocks,
              [bgmId]: true,
            },
          }));
          return true;
        }
        return false;
      },
    }),
    {
      name: 'sorarium-audio-storage',
      partialize: (state) => ({
        audioSettings: state.audioSettings,
        bgmUnlocks: state.bgmUnlocks,
      }),
    }
  )
);